export const fallbackImage =
  "https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&w=900&q=72";

export const destinationChips = [
  { name: "Kerala", count: "42 stays", image: "/landing/original/destination-kerala.jpg" },
  { name: "Rajasthan", count: "35 stays", image: "/landing/original/destination-rajasthan.jpg" },
  { name: "Goa", count: "58 stays", image: "/landing/original/destination-goa.png" },
  { name: "Himachal", count: "27 stays", image: "/landing/original/destination-himachal.jpg" },
  { name: "Udaipur", count: "18 stays", image: "/landing/original/popular-card-2.jpg" },
  { name: "Mumbai", count: "21 stays", image: "/landing/original/featured-card-3.jpg" },
  { name: "Jaipur", count: "29 stays", image: "/landing/original/popular-card-1.jpg" },
  { name: "Rishikesh", count: "16 stays", image: "/landing/original/curated-card-2.jpg" },
];

export const fallbackProperties = [
  {
    id: "fallback-1",
    title: "Maroon Courtyard Pool Villa",
    location: "Assagao, Goa",
    image: "/landing/original/trending-card-1.jpg",
    price: 18500,
    rating: 4.8,
    guests: 8,
    bedrooms: 4,
    link: "/stays",
  },
  {
    id: "fallback-2",
    title: "Heritage Haveli Stay",
    location: "Udaipur, Rajasthan",
    image: "/landing/original/featured-card-2.jpg",
    price: 22000,
    rating: 4.9,
    guests: 10,
    bedrooms: 5,
    link: "/stays",
  },
  {
    id: "fallback-3",
    title: "Tea Garden Mountain Villa",
    location: "Munnar, Kerala",
    image: "/landing/original/curated-card-3.jpg",
    price: 14500,
    rating: 4.7,
    guests: 6,
    bedrooms: 3,
    link: "/stays",
  },
];

export const packageCards = [
  { title: "Royal Rajasthan", meta: "5 nights | Udaipur, Jaipur", image: "/landing/original/destination-rajasthan.jpg" },
  { title: "Goa Villa Escape", meta: "3 nights | Private pool stays", image: "/landing/original/destination-goa.png" },
  { title: "Kerala Slow Travel", meta: "6 nights | Hills and backwaters", image: "/landing/original/destination-kerala.jpg" },
];

export const cabTypes = [
  { title: "Premium Sedan", meta: "Airport and city transfers" },
  { title: "Luxury SUV", meta: "Families, hills and long routes" },
  { title: "Tempo Traveller", meta: "Groups and destination weddings" },
];

